/* Popup de bienvenida "Tenés 10% OFF" (inspirado en el de Grüns). 2026-10-13.
   Se abre al tocar la solapa lateral (#sidetab a), con window.MkBienvenida.abrir(), o SOLO a los 10 s para quien entra
   por primera vez (ver autoAbrir: una vez por visitante, se vuelve a ofrecer recién a los 7 días si lo cerró sin completarlo).
   Pasos: 1 email · 2 momento del día · 3 memotest (3 cartas iguales) · 4 premio + recomendación.
   Prototipo: el email no se envía a ningún lado ni se guarda; solo se recuerda (localStorage) que se completó y el momento. */
(function () {
  'use strict';
  var CLAVE = 'mk-bienvenida';
  var CODIGO = 'HOLA10';
  var MOMENTOS = {
    manana:   { txt: 'Para arrancar la mañana',   reco: [['Melena de León', 'melena'], ['Ginseng', 'ginseng']] },
    tarde:    { txt: 'Para una pausa a la tarde', reco: [['Ashwagandha', 'ashwa']] },
    noche:    { txt: 'Para la noche',             reco: [['Reishi', 'reishi']] },
    entrenar: { txt: 'Para antes de entrenar',    reco: [['Cordyceps', 'cordyceps']] }
  };
  var COLORES = ['#4F543E', '#FFFAE5', '#E49444', '#6D8469', '#B17E2F', '#6E2933'];

  var raiz, dialogo, previo, vueltas = 0, momento = null, bloqueado = false, timers = [];
  var quieto = function () { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; };

  function leer() { try { return JSON.parse(localStorage.getItem(CLAVE)) || null; } catch (e) { return null; } }
  function guardar(o) { try { localStorage.setItem(CLAVE, JSON.stringify(o)); } catch (e) {} }
  function $(s, c) { return (c || raiz).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || raiz).querySelectorAll(s)); }
  function luego(fn, ms) { timers.push(setTimeout(fn, ms)); }

  function construir() {
    var cartas = '';
    for (var i = 0; i < 9; i++) {
      cartas += '<button type="button" class="mkb-carta" aria-label="Carta ' + (i + 1) + ', dar vuelta">' +
        '<span class="mkb-carta-in"><span class="mkb-cara mkb-cara--frente" aria-hidden="true">?</span>' +
        '<span class="mkb-cara mkb-cara--dorso" aria-hidden="true"><span><b>10%</b>OFF</span></span></span></button>';
    }
    var botones = Object.keys(MOMENTOS).map(function (k) {
      return '<button type="button" class="mkb-btn" data-momento="' + k + '">' + MOMENTOS[k].txt + '</button>';
    }).join('');
    var iso = '<span class="mkb-iso"><i class="a"></i><i class="l"></i></span>';

    raiz = document.createElement('div');
    raiz.className = 'mkb';
    raiz.hidden = true;
    raiz.innerHTML =
      '<div class="mkb-dialog" role="dialog" aria-modal="true" aria-labelledby="mkb-tit-1" tabindex="-1" data-paso="1">' +
        '<figure class="mkb-foto"><img src="' + window.MKA + 'secciones-bienvenida.webp" alt=""></figure>' +
        '<div class="mkb-panel">' +
          '<div class="mkb-cont">' +
            '<p class="mkb-logo" aria-hidden="true">mykora.</p>' +

            '<section class="mkb-paso" data-paso="1">' +
              '<h2 class="mkb-tit" id="mkb-tit-1" tabindex="-1"><span>¡Ganaste</span><span class="mkb-num">10% OFF!</span></h2>' +
              '<p class="mkb-baja">en tu primera compra. Dejanos tu email para guardarlo.</p>' +
              '<form class="mkb-form" novalidate>' +
                '<label class="mkb-sr" for="mkb-email" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">Tu email</label>' +
                '<input class="mkb-input" id="mkb-email" type="email" name="email" placeholder="Tu email" autocomplete="email" inputmode="email" aria-describedby="mkb-error">' +
                '<p class="mkb-error" id="mkb-error" aria-live="polite"></p>' +
                '<button type="submit" class="mkb-btn">Continuar</button>' +
              '</form>' +
            '</section>' +

            '<section class="mkb-paso" data-paso="2" hidden>' +
              '<h2 class="mkb-tit" id="mkb-tit-2" tabindex="-1"><span>Tenés</span><span class="mkb-num">10% OFF</span></h2>' +
              '<p class="mkb-txt">Para reclamarlo, contanos para qué momento lo buscás:</p>' +
              '<div class="mkb-momentos">' + botones + '</div>' +
            '</section>' +

            '<section class="mkb-paso" data-paso="3" hidden>' +
              '<h2 class="mkb-tit mkb-tit--chico" id="mkb-tit-3" tabindex="-1">Probá tu suerte</h2>' +
              '<p class="mkb-txt">Encontrá 3 cartas iguales para ver qué ganás.</p>' +
              '<div class="mkb-cartas">' + cartas + '</div>' +
              '<p class="mkb-error" aria-live="polite" id="mkb-vivo" style="color:inherit"></p>' +
            '</section>' +

            '<section class="mkb-paso" data-paso="4" hidden>' +
              '<h2 class="mkb-tit mkb-tit--chico" id="mkb-tit-4" tabindex="-1"><span>Tu código</span><span class="mkb-num">10% OFF</span></h2>' +
              '<div class="mkb-codigo"><code>' + CODIGO + '</code><button type="button" class="mkb-copiar">Copiar</button></div>' +
              '<p class="mkb-reco"></p>' +
              '<a class="mkb-btn" href="/collections/all">Ir a la tienda</a>' +
              
            '</section>' +
          '</div>' +
        '</div>' +
        '<div class="mkb-flota" aria-hidden="true">' + iso + iso + iso + iso + '</div>' +
        '<button type="button" class="mkb-x" aria-label="Cerrar"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '</div>';
    document.body.appendChild(raiz);
    dialogo = $('.mkb-dialog');

    // paso 1: email
    $('.mkb-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = $('#mkb-email'), v = inp.value.trim(), err = $('#mkb-error');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        inp.setAttribute('aria-invalid', 'true');
        err.textContent = v ? 'Revisá el email, parece que le falta algo.' : 'Escribí tu email para seguir.';
        inp.focus();
        return;
      }
      inp.removeAttribute('aria-invalid');
      err.textContent = '';
      try { var fd = new FormData(); fd.append('form_type', 'customer'); fd.append('utf8', '✓'); fd.append('contact[email]', v);
        fd.append('contact[tags]', 'newsletter,popup-bienvenida'); fd.append('contact[accepts_marketing]', 'true');
        fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {}); } catch (x) {}
      irA(2);
    });
    $('#mkb-email').addEventListener('input', function () {
      if (this.getAttribute('aria-invalid')) { this.removeAttribute('aria-invalid'); $('#mkb-error').textContent = ''; }
    });

    // paso 2: momento
    $$('[data-momento]').forEach(function (b) {
      b.addEventListener('click', function () { momento = b.getAttribute('data-momento'); guardar({ hecho: true, momento: momento }); irA(4); });
    });

    // paso 3: cartas
    $$('.mkb-carta').forEach(function (c) {
      c.addEventListener('click', function () { voltear(c); });
    });

    // paso 4: copiar
    $('.mkb-copiar').addEventListener('click', copiar);

    $('.mkb-x').addEventListener('click', cerrar);
    raiz.addEventListener('keydown', teclado);
  }

  function irA(n) {
    dialogo.setAttribute('data-paso', String(n));
    dialogo.setAttribute('aria-labelledby', 'mkb-tit-' + n);
    $$('.mkb-paso').forEach(function (p) { p.hidden = p.getAttribute('data-paso') !== String(n); });
    $('.mkb-panel').scrollTop = 0;
    if (n === 3) reiniciarCartas();
    if (n === 4) pintarPremio();
    enfocar(n);
  }

  function enfocar(n) {
    var obj = n === 1 ? $('#mkb-email') : $('#mkb-tit-' + n);
    try { obj.focus({ preventScroll: true }); } catch (e) { obj.focus(); }
  }

  function reiniciarCartas() {
    vueltas = 0; bloqueado = false;
    $('#mkb-vivo').textContent = '';
    $$('.mkb-carta').forEach(function (c, i) {
      c.classList.remove('vuelta'); c.disabled = false;
      c.setAttribute('aria-label', 'Carta ' + (i + 1) + ', dar vuelta');
    });
  }

  function voltear(c) {
    if (bloqueado || c.classList.contains('vuelta')) return;
    c.classList.add('vuelta');
    c.disabled = true;
    c.setAttribute('aria-label', '10% OFF');
    vueltas++;
    $('#mkb-vivo').textContent = vueltas < 3 ? '10% OFF. Llevás ' + vueltas + ' de 3.' : '¡3 iguales!';
    if (vueltas === 3) {
      bloqueado = true;
      $$('.mkb-carta').forEach(function (x) { x.disabled = true; });
      if (quieto()) { luego(function () { irA(1); }, 700); return; }
      luego(confeti, 650);
      luego(function () { irA(1); }, 1900);
    }
  }

  /* Confeti chico. Se anima con setTimeout (no requestAnimationFrame) para que avance igual si la pestaña o el panel
     de pruebas están en segundo plano (DESIGN_MEMORY R30). El paso 4 no depende de que termine. */
  function confeti() {
    if (quieto()) return;
    var capa = document.createElement('div');
    capa.className = 'mkb-confeti';
    var ref = $('.mkb-cartas').getBoundingClientRect(), base = dialogo.getBoundingClientRect();
    var cx = ref.left + ref.width / 2 - base.left, cy = ref.top + ref.height / 2 - base.top;
    var ps = [];
    for (var i = 0; i < 70; i++) {
      var el = document.createElement('i');
      el.style.background = COLORES[i % COLORES.length];
      if (COLORES[i % COLORES.length] === '#FFFAE5') el.style.boxShadow = '0 0 0 1px rgba(79,84,62,.25)';
      if (i % 3 === 0) { el.style.width = '7px'; el.style.height = '7px'; el.style.borderRadius = '50%'; }
      capa.appendChild(el);
      var ang = Math.random() * Math.PI * 2, vel = 5 + Math.random() * 9;
      ps.push({ el: el, x: cx, y: cy, vx: Math.cos(ang) * vel, vy: Math.sin(ang) * vel - 7, r: Math.random() * 360, vr: (Math.random() - .5) * 24 });
    }
    dialogo.appendChild(capa);
    var t = 0;
    (function paso() {
      t++;
      ps.forEach(function (p) {
        p.vy += .42; p.vx *= .985; p.x += p.vx; p.y += p.vy; p.r += p.vr;
        p.el.style.transform = 'translate(' + p.x.toFixed(1) + 'px,' + p.y.toFixed(1) + 'px) rotate(' + p.r.toFixed(0) + 'deg)';
        p.el.style.opacity = t > 55 ? Math.max(0, 1 - (t - 55) / 30) : 1;
      });
      if (t < 85) luego(paso, 16); else capa.remove();
    })();
  }

  function pintarPremio() {
    var m = MOMENTOS[momento] || null, p = $('.mkb-reco');
    if (!m) { p.innerHTML = 'Usalo en cualquier tintura de la <a href="/collections/all">tienda</a>.'; return; }
    var links = m.reco.map(function (r) { return '<a href="' + window.MKP.t[r[1]] + '">' + r[0] + '</a>'; }).join(' o ');
    p.innerHTML = m.txt + ', te recomendamos ' + links + '.';
  }

  function copiar() {
    var b = $('.mkb-copiar');
    var listo = function () { b.textContent = 'Copiado'; luego(function () { b.textContent = 'Copiar'; }, 1800); };
    var viejo = function () {
      var ta = document.createElement('textarea');
      ta.value = CODIGO; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      raiz.appendChild(ta); ta.select();
      try { document.execCommand('copy'); listo(); } catch (e) { b.textContent = 'Copialo a mano'; }
      ta.remove(); b.focus();
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(CODIGO).then(listo, viejo);
    else viejo();
  }

  function teclado(e) {
    if (e.key === 'Escape') { e.preventDefault(); cerrar(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('button:not([disabled]), a[href], input, [tabindex="0"]', dialogo).filter(function (el) {
      return el.offsetParent !== null || el === $('.mkb-x');
    });
    if (!f.length) return;
    var pri = f[0], ult = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === pri || !dialogo.contains(document.activeElement) || document.activeElement === dialogo)) { e.preventDefault(); ult.focus(); }
    else if (!e.shiftKey && document.activeElement === ult) { e.preventDefault(); pri.focus(); }
  }

  var scrollPrevio = { html: '', body: '', pad: '' };
  function abrir() {
    if (!raiz) construir();
    if (!raiz.hidden) return;
    previo = document.activeElement;
    var barra = window.innerWidth - document.documentElement.clientWidth;
    scrollPrevio = { html: document.documentElement.style.overflow, body: document.body.style.overflow, pad: document.body.style.paddingRight };
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    if (barra > 0) document.body.style.paddingRight = barra + 'px';
    raiz.hidden = false;
    var guardado = leer();
    if (guardado && guardado.hecho) { momento = guardado.momento || null; irA(4); }
    else irA(3);   // arranca con el juego, como Grüns
  }

  function cerrar() {
    if (!raiz || raiz.hidden) return;
    timers.forEach(clearTimeout); timers = [];
    var c = $('.mkb-confeti', dialogo); if (c) c.remove();
    raiz.hidden = true;
    // si se cerró a mitad del juego, al volver arranca el juego de nuevo; email y momento quedan en memoria de la página
    document.documentElement.style.overflow = scrollPrevio.html;
    document.body.style.overflow = scrollPrevio.body;
    document.body.style.paddingRight = scrollPrevio.pad;
    if (previo && previo.focus && document.contains(previo)) { try { previo.focus({ preventScroll: true }); } catch (e) { previo.focus(); } }
  }

  function enganchar() {
    var tab = document.getElementById('sidetab');
    if (!tab) return;
    var a = tab.querySelector('a');
    if (!a || !/CLUB|10\s*%/i.test(a.textContent)) return;
    if (/^CLUB\s*[−-]\s*10%$/.test(a.textContent.trim())) a.textContent = '10% OFF';
    a.setAttribute('aria-haspopup', 'dialog');
    a.addEventListener('click', function (e) { e.preventDefault(); abrir(); });
  }

  window.MkBienvenida = {
    abrir: abrir,
    cerrar: cerrar,
    reiniciar: function () { try { localStorage.removeItem(CLAVE); localStorage.removeItem('mk-bienvenida-visto'); } catch (e) {} momento = null; if (raiz && !raiz.hidden) irA(3); }
  };

  // ----- se abre solo a los 10 s para visitantes nuevos (como Grüns, Ritual, AG1) -----
  // Reglas: nunca si ya lo completó; si lo cerró sin completar, no se vuelve a mostrar por 7 días;
  // no interrumpe si el carrito o el menú están abiertos, si la pestaña no está a la vista o si la persona ya está escribiendo.
  var VISTO = 'mk-bienvenida-visto', ESPERA = 10000, SILENCIO = 7 * 24 * 3600 * 1000;
  function autoAbrir() {
    var g = leer(); if (g && g.hecho) return;
    var visto = 0; try { visto = +localStorage.getItem(VISTO) || 0; } catch (e) {}
    if (visto && Date.now() - visto < SILENCIO) return;
    setTimeout(function intentar() {
      if (raiz && !raiz.hidden) return;
      var ocupado = document.querySelector('.ck.on, .menu.on, .menu.open, dialog[open]') || document.hidden ||
        (document.activeElement && /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName));
      if (ocupado) { setTimeout(intentar, 4000); return; }
      try { localStorage.setItem(VISTO, String(Date.now())); } catch (e) {}
      abrir();
    }, ESPERA);
  }

  function iniciar() { enganchar(); autoAbrir(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
